import * as types from '../mutation-types'

// initial state
const state = {
  sid: null
}

// getters
const getters = {
  getSid: state => state.sid
}

// actions
const actions = {
  changeStudy ({ commit }, payload) {
    commit(types.CHANGE_STUDYID, payload)
  }
}

// mutations
const mutations = {
  [types.CHANGE_STUDYID] (state, payload) {
    state.sid = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
